import FormatAlignJustifyIcon from '@mui/icons-material/FormatAlignJustify';
import HtmlIcon from '@mui/icons-material/Html';
import HexagonIcon from '@mui/icons-material/Hexagon';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import Filter1Icon from '@mui/icons-material/Filter1';
import PublicIcon from '@mui/icons-material/Public';
import PaymentsIcon from '@mui/icons-material/Payments';
import SecurityIcon from '@mui/icons-material/Security';
import KeyIcon from '@mui/icons-material/Key';
import LockIcon from '@mui/icons-material/Lock';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CalculateIcon from '@mui/icons-material/Calculate';
import AddIcon from '@mui/icons-material/Add';
import WorkOutlineIcon from '@mui/icons-material/WorkOutline';
import HomeIcon from '@mui/icons-material/Home';
import CodeIcon from '@mui/icons-material/Code';

export interface SubFeature {
  key: string;
  label: string;
  tabKey: string;
  icon: React.ReactElement;
}

export interface ParentFeature {
  key: string;
  label: string;
  path: string;
  icon: React.ReactElement;
  subFeatures: SubFeature[];
}

export const featureStructure: ParentFeature[] = [
  {
    key: 'datetime-utility',
    label: 'DateTime & Calendar',
    path: 'datetime-utility',
    icon: <CalendarMonthIcon />,
    subFeatures: [
      { key: 'add-days', label: 'Add Days', tabKey: 'add-days', icon: <AddIcon /> },
      { key: 'date-gap-count', label: 'Date Gap Count', tabKey: 'date-gap-count', icon: <CalculateIcon /> },
      { key: 'work-days-calc', label: 'Work Days Calculator', tabKey: 'work-days-calc', icon: <WorkOutlineIcon /> },
      { key: 'world-clock', label: 'World Clock', tabKey: 'world-clock', icon: <AccessTimeIcon /> },
      { key: 'nz-holidays', label: 'NZ Public Holidays', tabKey: 'nz-holidays', icon: <PublicIcon /> },
    ]
  },
  {
    key: 'financial',
    label: 'Financial Tools',
    path: 'financial',
    icon: <PaymentsIcon />,
    subFeatures: [
      { key: 'interest-calculation', label: 'Interest Calculation', tabKey: 'interest-calculation', icon: <CalculateIcon /> },
      { key: 'mortgage-break-calculate', label: 'Mortgage Break Calculator', tabKey: 'mortgage-break-calculate', icon: <HomeIcon /> },
    ]
  },
  {
    key: 'security-utilities',
    label: 'Security & Utilities',
    path: 'utilities',
    icon: <SecurityIcon />,
    subFeatures: [
      { key: 'guid-generator', label: 'GUID Generator', tabKey: 'guid-generator', icon: <KeyIcon /> },
      { key: 'password-generator', label: 'Password Generator', tabKey: 'password-generator', icon: <KeyIcon /> },
      { key: 'password-strength', label: 'Password Strength Checker', tabKey: 'password-strength', icon: <LockIcon /> },
    ]
  },
  {
    key: 'dev-tools',
    label: 'Developer Tools',
    path: 'dev-tools',
    icon: <CodeIcon />,
    subFeatures: [
      { key: 'json-beautifier', label: 'JSON Beautifier', tabKey: 'json-beautifier', icon: <FormatAlignJustifyIcon /> },
      { key: 'html-viewer', label: 'HTML Viewer', tabKey: 'html-viewer', icon: <HtmlIcon /> },
      { key: 'hex-to-pantone', label: 'HEX to Pantone', tabKey: 'hex-to-pantone', icon: <HexagonIcon /> },
      { key: 'binary-to-decimal', label: 'Binary to Decimal', tabKey: 'binary-to-decimal', icon: <Filter1Icon /> },
    ]
  }
];

// Utility function to create a flattened searchable list from the hierarchical structure
export interface SearchableFeature {
  key: string;
  label: string;
  path: string;
  tabKey?: string;
  icon: React.ReactElement;
  parentLabel?: string;
}

export const getSearchableFeatures = (): SearchableFeature[] => {
  const features: SearchableFeature[] = [];
  
  featureStructure.forEach(parent => {
    // Add parent features
    features.push({
      key: parent.key,
      label: parent.label,
      path: parent.path,
      icon: parent.icon
    });
    
    // Add sub-features with parent context
    parent.subFeatures.forEach(sub => {
      features.push({
        key: sub.key,
        label: sub.label,
        path: `${parent.path}?tab=${sub.tabKey}`,
        tabKey: sub.tabKey,
        icon: sub.icon,
        parentLabel: parent.label
      });
    });
  });
  
  return features;
};

// For backward compatibility with existing search functionality
export const searchableFeatures = getSearchableFeatures();